<template>
    <div class="submit-material">
        <Button class="add-btn" v-if="infoCtrl&&isDetailLoad" type="primary" @click="getDetail('edit')">修改</Button>
        <Row v-if="!infoCtrl&&isDetailLoad">
            <Form ref="formData" class="case-form" :model="formData" :rules="ruleValidate" :label-width="100">
                <FormItem label="申请缘由" prop="reason">
                    <Input v-model="formData.reason" type="textarea" placeholder="请填写申请缘由"></Input>
                </FormItem>
                <FormItem label="控告当事人" prop="litigantIdList">
                    <Select v-model="formData.litigantIdList" multiple placeholder="请选择控告当事人" label-in-value @on-change="getSelectValue">
                        <Option v-for="item in litigantIdArr" :value="item.id" :key="item.id" :label="item.name" :tag="item.name">
                            <div class="litigant-info textover">名称：{{item.name}} --- 法人：{{item.legalRepresentative}}</div>
                            <div>地址：{{item.provinceName}}{{item.cityName}}{{item.areaName}}{{item.address}}</div>
                        </Option>
                    </Select>
                </FormItem>
                <!-- 授权委托书 | 刑事控告书 | 承诺书 必填 -->
                <FormItem 
                    v-for="(item,index) in materialTypeArr" 
                    :label="item.nameZh" 
                    :key="index"
                    :prop="item.value+'attachs'"
                    :rules="(item.value=='PA' || item.value=='CO' || item.value=='CC')?ruleValidate.subject:[]">
                    <file-upload
                        :defaultList="defaultList[item.value+'attachs'] || []"
                        :uploadConfig="{}"
                        @getFileList="getAttachmentList($event,item.value)"></file-upload>
                </FormItem>
            </Form>
            <Row class="detail-btn-box">
                <Button type="primary" style="margin-right:10px;" :disabled="isSubmit" @click="submitNew">保存</Button>
                <Button v-if="defaultData" @click="infoCtrl=true">取消</Button>
            </Row>
        </Row>
        <Row class="detail-content" v-if="infoCtrl&&isDetailLoad">
            <Row><Col span="5" class="left-label">申请缘由：</Col><Col span="16" class="right-content">{{defaultData.reason}}</Col></Row>
            <Row><Col span="5" class="left-label">控告当事人：</Col><Col span="16" class="right-content">{{defaultData.litigantNames}}</Col></Row>
            <Row v-for="(item,index) in defaultData.administrativeApplyMaterialList" :key="index">
                <Col span="5" class="left-label">{{item.name}}：</Col>
                <Col span="16" class="right-content">
                    <file-upload
                        :defaultList="item.attachmentList || []" 
                        :uploadConfig="{readOnly:true}"></file-upload>
                </Col>
            </Row>
        </Row>
    </div>
</template>
<script>
export default {
    data () {
        const isFillIn = (rule, value, callback) => {
            let key = rule.fullField;
            if(this.formData[key] && this.formData[key].length>0){
                return callback();
            }
            return callback(new Error('请上传附件'));
        };
        return {
            isDetailLoad:false,
            infoCtrl:true,
            isSubmit:false,
            defaultData:"",
            litigantIdArr:[],//对方当事人
            defaultList:{},
            materialTypeArr:[],
            formData:{
                reason:"",
                litigantIdList:[],
                litigantIds:"",
                litigantNames:""
            },
            ruleValidate:{
                reason:[{required: true, message: '申请缘由不能为空', trigger: 'blur'}],
                litigantIdList:[{required: true,type:"array", message: '控告当事人不能为空', trigger: 'blur'}],
                subject:[{required: true,validator:isFillIn, trigger: 'blur'}],
            }
        }
    },
    props: ['processId','caseId'],
    methods: {
        materialDefaultData(){
            this.materialTypeArr.forEach((item,index)=>{
                let key = item.value + "attachs";
                this.defaultList[key] = [];
            })
        },
        //获取详情
        getDetail(type){
            let url = '/business/case/administrative/material-apply/'+this.processId;
            this.$get(url).then(res=>{
                if(res.code===0&&res.data){
                    this.defaultData = res.data;
                    this.$emit('getAuditState',true);
                    this.infoCtrl = type==='edit'?false:true;
                    if(type=='edit'){
                        this.giveDefaultData();
                    }
                    this.isDetailLoad = true;
                }else{
                    this.infoCtrl = false;
                    this.isDetailLoad = true;
                }
            })
        },
        //获取对方当事人
        getLitigantIdArr(){
            let url = '/business/litigants/lawyer?caseId='+this.caseId;
            this.$get(url).then(res=>{
                if(res.code===0){
                    this.litigantIdArr = res.data.filter(item=>{
                        if(item.type==='E'){ return item }
                    });
                }
            })
        },
        getAttachmentList(arr,key){
            this.formData[key+'attachs'] = [];
            arr.forEach((item)=>{
                let obj = {
                    fileName:item.fileName,
                    mediaType:item.mediaType,
                    smallUrl:item.smallUrl,
                    url:item.url
                }
                this.formData[key+'attachs'].push(obj);
            })
        },
        getSelectValue(arr){
            this.formData.litigantIds = "";
            this.formData.litigantNames = "";
            arr.forEach((item,index)=>{
                this.formData.litigantIds += index==0?item.value:`,${item.value}`;
                this.formData.litigantNames += index==0?item.label:`,${item.label}`;
            })
        },
        giveDefaultData(){
            this.formData.reason = this.defaultData.reason;
            this.formData.litigantIds = this.defaultData.litigantIds;
            this.formData.litigantNames = this.defaultData.litigantNames;
            let arr = this.defaultData.litigantIds.split(",");
            this.formData.litigantIdList = []; 
            arr.forEach((item,index)=>{
                this.formData.litigantIdList.push(Number(item));
            })
            this.defaultData.administrativeApplyMaterialList.forEach((item,index)=>{
                let key = item.type + "attachs";
                this.formData[key] = [];
                this.defaultList[key] = [];
                item.attachmentList.forEach((attItem)=>{
                    let obj = {
                        fileName:attItem.fileName,
                        mediaType:attItem.mediaType,
                        smallUrl:attItem.smallUrl,
                        url:attItem.url
                    }
                    this.formData[key].push(obj);
                    this.defaultList[key].push(obj);
                })
            })
            this.isDetailLoad = true;
        },
        submitNew(){
            let url = '/business/case/administrative/material-apply';
            let ajaxData = { 
                processId:this.processId,
                reason:this.formData.reason,
                caseId:this.caseId,
                litigantIds:this.formData.litigantIds,
                litigantNames:this.formData.litigantNames,
                administrativeApplyMaterialList:[]
            };
            this.materialTypeArr.forEach((item,index)=>{
                let arr = this.formData[item.value+"attachs"];
                if(arr && arr.length>0){
                    let obj = {
                        type:item.value,
                        name:item.nameZh,
                        attachmentList:arr
                    }
                    ajaxData.administrativeApplyMaterialList.push(obj);
                }
            })
            console.log(ajaxData)
            if(this.defaultData){
                ajaxData.id = this.defaultData.id;
                this.$refs['formData'].validate((valid) => {
                    if (valid) {
                        this.isSubmit = true;
                        this.$patch(url,ajaxData).then(res=>{
                            if(res.code===0){
                                this.getDetail();
                                this.$Message.success('操作成功');
                            }else{
                                this.$Message.error(res.message);
                            }
                            this.isSubmit = false;
                        })
                    }
                })
            }else{  
                this.$refs['formData'].validate((valid) => {
                    if (valid) {
                        this.isSubmit = true;
                        this.$post(url,ajaxData).then(res=>{
                            if(res.code===0){
                                this.$emit('reloadProcess');
                                this.$Message.success('操作成功');
                            }else{
                                this.$Message.error(res.message);
                            }
                            this.isSubmit = false;
                        })
                    }
                })
            } 
        },
        //获取字典数据接口
        async getDictionary(){
            this.materialTypeArr = await this.common.getDictionaryItems('administrative_material');
            this.materialDefaultData();
        },
    },
    created(){},
    beforeMount(){
        this.getDictionary();
        this.getLitigantIdArr();

        this.getDetail();
    },
    mounted(){},
    updated(){},
    components: {},
    watch: {}
}
</script>
<style scoped lang="scss">
@import '../../civilCase/caseCommon.scss';
.submit-material{
    .add-btn{
        margin-top:-64px;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/administrativeCase/administrativeApply/submitMaterial.vue